import { useTranslation } from "react-i18next";
import { createFileRoute, Link } from "@tanstack/react-router";
import { SunDim } from "lucide-react";
import { buttonVariants } from "@/components/ui/button";
import { isLoggedIn } from "@/hooks/useAuth";

export const API_DOCS_URL = import.meta.env.VITE_API_URL + "/docs";

export const Route = createFileRoute("/reset-password-success")({
  component: ResetPasswordSuccessPage,
});

function ResetPasswordSuccessPage() {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-screen flex-col items-center justify-between overflow-hidden p-2">
      <nav className="flex w-full justify-end">
        {isLoggedIn() ? (
          <Link to="/clientsheets" className={buttonVariants()}>
            {t("Dashboard")}
          </Link>
        ) : (
          <Link to="/login" className={buttonVariants()}>
            {t("Login")}
          </Link>
        )}
      </nav>

      <section className="flex flex-col items-center justify-center gap-4">
        <SunDim className="h-16 w-16 text-primary" />
        <h1 className="text-2xl font-semibold tracking-tight">{t("API password reset successful")}</h1>
        <p className="text-sm text-muted-foreground">{t("Your API password has been reset successfully")}</p>
        <a
          href={API_DOCS_URL}
          className="text-balance text-center text-sm text-muted-foreground"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("Visit the OPENAPI documentation")}: <span className="underline">{API_DOCS_URL}</span>
        </a>
      </section>

      <footer>
        <h2 className="text-balance text-center text-2xl font-bold text-muted-foreground">
          Brainchild Commodity Intelligence
        </h2>
      </footer>
    </main>
  );
}
